import { Text, TextAlign } from 'shared/ui/Text/Text'
import cls from './WantListItem.module.scss'
import { CheckIcon, MoreIcon } from 'shared/ui/Icon'
import { useState } from 'react'
import { animated } from '@react-spring/web'
import { Menu } from 'widgets/Menu/Menu'
import { parser } from 'shared/lib/parser/parser'
import { ImageWithSkeleton } from 'shared/ui/ImageWithSkeleton'

export const WantListItem = (props) => {
    const {
        readonly,
        text,
        img,
        id,
        style,
        toAcceptedMoment,
        toRejectedMoment,
        toPinnedMoment,
        fromPinnedMoment,
        pinned,
    } = props

    const [settings, setSettings] = useState(false)

    const onSettings = () => {
        setSettings(true)
    }

    const onCloseSettings = () => {
        setSettings(false)
    }

    const parsedText = parser(text)

    if (readonly) {
        return (
            <>
                <animated.div style={style} className={cls.WantListItem}>
                    <ImageWithSkeleton
                        className={cls.Img}
                        alt="img"
                        src={img}
                    />
                    <Text align={TextAlign.LEFT} className={cls.Text}>
                        <b>{parsedText[0]}</b> {parsedText[1]}
                    </Text>
                    {/* <>
						<button
							onClick={
								disabled
									? () => {
											toWantedMoment(id)
									  }
									: null
							}
							className={classNames(cls.Button, mods, [])}
						>
							<img alt="check" className={cls.Check} src={icon} />
						</button>
					</> */}
                </animated.div>
                <div className={cls.Dots} />
            </>
        )
    }

    return (
        <>
            <animated.div style={style} className={cls.WantListItem}>
                {settings ? (
                    <Menu
                        isPinned={pinned}
                        cardId={id}
                        onCloseSettings={onCloseSettings}
                        toRejectedMoment={toRejectedMoment}
                        toPinnedMoment={toPinnedMoment}
                        fromPinnedMoment={fromPinnedMoment}
                    />
                ) : null}
                <ImageWithSkeleton className={cls.Img} alt="img" src={img} />
                <Text align={TextAlign.LEFT} className={cls.Text}>
                    <b>{parsedText[0]}</b> {parsedText[1]}
                </Text>
                <>
                    <button
                        onClick={() => toAcceptedMoment(id)}
                        className={cls.AcceptButton}
                    >
                        <CheckIcon className={cls.Check} />
                    </button>
                    <button onClick={onSettings} className={cls.SettingsButton}>
                        <MoreIcon className={cls.Inside} />
                    </button>
                </>
            </animated.div>
            <div className={cls.Dots} />
        </>
    )
}
